import { connect } from "react-redux";
import UserAvatar from "./userAvatar";
const mapStateToProps = (state, ownProps) => ({
    avatar: ownProps.avatar !== undefined ? ownProps.avatar : state[ownProps.userId]
});
export default connect(mapStateToProps)(UserAvatar);
